import { IBudgetStatusCounts } from "../../../../models/budgetV2";
import { useIntl } from "react-intl";

interface BudgetKanbanStatusCountsProps {
  statusCounts: IBudgetStatusCounts;
  loading?: boolean;
  persona?: string;
}

const BudgetKanbanStatusCounts = ({ statusCounts, loading = false, persona }: BudgetKanbanStatusCountsProps) => {
  const intl = useIntl();
  const isManager = persona === "MANAGER";

  const getBorderColor = (key: string): string => {
    switch (key) {
      case "sent":
        return "#6B7280";
      case "altered":
      case "counterproposal":
        return "#F97316";
      case "approved":
        return "#10B981";
      case "rejected":
        return "#EF4444";
      default:
        return "#6B7280";
    }
  };

  const cards = isManager
    ? [
        { key: "sent", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.sent" }) },
        { key: "counterproposal", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.counterproposal" }) },
        { key: "approved", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.approved" }) },
        { key: "rejected", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.rejected" }) },
      ]
    : [
        { key: "sent", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.sent" }) },
        { key: "altered", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.altered" }) },
        { key: "counterproposal", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.counterproposal" }) },
        { key: "approved", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.approved" }) },
        { key: "rejected", label: intl.formatMessage({ id: "intl-msg:budgets.kanban.summary.rejected" }) },
      ];

  return (
    <div className="margin-bottom-20 md:min-w-[1024px] max-w-[2048px] mx-auto">
      <div className="md:flex flex-row gap-4 items-stretch w-full">
        {cards.map((card) => (
          <div
            key={card.key}
            className="bg-white rounded-lg shadow-sm border-l-4 flex-1 p-5 flex flex-col justify-start items-start w-full md:w-auto mb-4 md:mb-0"
            style={{
              borderLeftColor: getBorderColor(card.key),
              borderLeftWidth: "4px",
            }}
          >
            <div className="w-full flex flex-col gap-2">
              <div className="text-size-14 font-normal text-gray-600 text-left leading-tight">
                {card.label}
              </div>
              <div className="text-[36px] font-bold text-gray-900 text-left leading-none font-sans">
                {loading ? "-" : statusCounts[card.key as keyof IBudgetStatusCounts]}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BudgetKanbanStatusCounts;
